<template>
	<div class="title-container width-100 display-flex flex-align-center flex-row px-1">
		<InsertDataPreviewIcon :iconName="iconName" v-if="iconName" class="mr-1" />
		{{ title }}
	</div>
</template>

<script>
import InsertDataPreviewIcon from '@/components/DataInput/DataInputMenu/InsertDataPreviewIcon';
export default {
	name: 'SubMenuTitle',
	props: {
		title: { type: String },
		iconName: { type: String },
	},
	components: {
		InsertDataPreviewIcon,
	},
};
</script>
<style lang="scss" scoped>
.title-container {
	height: 22px;
	background: var(--sub-title-background);

	font-size: 10px;
	color: var(--sub-title-text-color);

	.icon-card {
		width: 19px;
		height: 19px;
		border-radius: 4px;
		border: 1px solid var(--border-color);
	}
}
</style>
